<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.0625 8L8 14.75L2.93652 8L8 1.24902L13.0625 8Z" stroke="currentColor" stroke-width="1.5"/>
</svg>
